import { render, staticRenderFns } from "./what-we-do.vue?vue&type=template&id=fea6abaa&scoped=true&"
import script from "./what-we-do.vue?vue&type=script&lang=js&"
export * from "./what-we-do.vue?vue&type=script&lang=js&"
import style0 from "./what-we-do.vue?vue&type=style&index=0&id=fea6abaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea6abaa",
  null
  
)

export default component.exports